import {useNavigate} from "react-router-dom";
import ImageSlider from "../components/ImageSlider";
import Modal from "../components/Modal";
import React, {useState} from "react";
import Slider3Image from "../components/ImageSlider/Slider3Image";
import {useEffect} from "react";
import {useSweetAlert} from "../context/sweetAlertContext";

export default function Dashboard() {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenFara, setIsOpenFara] = useState(false);
    const [isOpenShooka, setIsOpenShooka] = useState(false);
    const [isOpenBaran, setIsOpenBaran] = useState(false);
    const [isOpenMehr, setIsOpenMehr] = useState(false);
    const sweetAlert = useSweetAlert()

    useEffect(() => {
    }, []);

    const showKarsoodRules = () => {

        sweetAlert({
            show: true,
            title: null,
            icon: 'warning',
            text: `قوانین، مقررات و نحوه فعالیت در کارسود را به صورت کامل مطالعه نمایید و سپس اقدام به فعالیت در آن کنید، اینوست بیمه هیچ مسئولیتی در خصوص فعالیت شما در کارسود نخواهد داشت`,
            confirmButtonText: "ورود به کارسود",
            customClass: {
                confirmButton: 'btn btn-lg btn-warning',
            },
            onConfirm: () => {window.open('https://karsood.ir', '_blank')},
        })
    };

    return (
        <>
            <div className="container-xxl flex-grow-1 container-p-y pb-1">
                <div className="row">
                    <div className="col-12">

                        <div className="row gy-4">
                            {/*<p className={"text-center m-1"}>*/}
                            {/*<img src="/images/logo11.webp" className={"w-px-100 me-2 "}/>*/}
                            {/*</p>*/}
                            <strong className={"text-center m-1 mt-4"}>آینده را امروز تجربه کنید</strong>
                            <strong className={"text-center m-1 mb-4"}>به اینوست بیمه، بیمه سرمایه گذاری خوش آمدید</strong>
                            <div className="col-12 m-1">
                                <ImageSlider/>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <div className="col-12">


                    <p className={"text-center m-0 font-12 mt-0 "}><strong>نماینده فروش بیمه های عمر، مستمری</strong></p>
                    <p className={"text-center m-0 font-12 mb-4"}><strong>بازنشستگی و سرمایه گذاری</strong></p>

                    <div className={'bg-blue text-white pb-4 pt-4'}>
                        <p className={"text-center m-0 font-12 "}><strong>همکاری با </strong></p>
                        <p className={"text-center m-0 font-12"}><strong>سوپر اپلیکیشن کسب درآمد کارسود</strong></p>
                        <p className={"text-center m-1"}>
                            <img src="/images/mobile.png" className={"w-px-250 me-2 "}/>
                        </p>
                        <div className={"col-12 centered text-center"}>
                            <p className={"font-12"}>با شماره همراه و رمز ورودتان در اینوست بیمه وارد کارسود شوید</p>
                            <div onClick={() => showKarsoodRules()} className={"text-center m-1 btn btn-warning text-white m-auto"} >ورود به کارسود</div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="container-xxl flex-grow-1 container-p-y">
            <div className="col-xl-12">
                <div className="card">
                    <h5 className="card-header ">مزایای اینوست بیمه</h5>
                    <div className="card-body">
                        <ul className="timeline timeline-dashed mt-4">
                            <li className="timeline-item timeline-item-primary mb-4">
                          <span className="timeline-indicator timeline-indicator-primary">
                           1
                          </span>
                                <div className="timeline-event">
                                    <div className="timeline-header  ">
                                        <h6 className="mb-2 font-12">همکاری با قدرتمندترین شرکت های بیمه ای </h6>
                                    </div>
                                </div>
                            </li>
                            <li className="timeline-item timeline-item-success mb-4">
                          <span className="timeline-indicator timeline-indicator-success">
                            2
                          </span>
                                <div className="timeline-event">
                                    <div className="timeline-header mb-sm-0 mb-3">
                                        <h6 className="mb-1 font-12">پرداخت وام بدون چک سفته و ضامن</h6>

                                    </div>

                                </div>
                            </li>
                            <li className="timeline-item timeline-item-danger mb-4">
                          <span className="timeline-indicator timeline-indicator-danger">
                            3
                          </span>
                                <div className="timeline-event">
                                    <div className="timeline-header mb-sm-0 mb-3">
                                        <h6 className="mb-1 font-12">پرداخت سود تضمینی توسط شرکت بیمه</h6>

                                    </div>
                                </div>
                            </li>
                            <li className="timeline-item timeline-item-info mb-4">
                          <span className="timeline-indicator timeline-indicator-info">
                            4
                          </span>
                                <div className="timeline-event">
                                    <div className="timeline-header">
                                        <h6 className="mb-1 font-12">بهره مندی از مزایای پوششهای مختلف بیمه ای</h6>

                                    </div>


                                </div>
                            </li>
                            <li className="timeline-item timeline-item-dark mb-4">
                          <span className="timeline-indicator timeline-indicator-dark">
                            5
                          </span>
                                <div className="timeline-event">
                                    <div className="timeline-header">
                                        <h6 className="mb-0 font-12">امکان بازنشستگی زودهنگام (5 ساله)</h6>

                                    </div>
                                </div>
                            </li>
                            <li className="timeline-item timeline-item-primary mb-4">
                          <span className="timeline-indicator timeline-indicator-primary">
                           6
                          </span>
                                <div className="timeline-event">
                                    <div className="timeline-header  ">
                                        <h6 className="mb-2 font-12">بازنشستگی با مستمری ماهیانه بالا </h6>
                                    </div>
                                </div>
                            </li>
                            <li className="timeline-item timeline-item-success mb-4">
                          <span className="timeline-indicator timeline-indicator-success">
                            7
                          </span>
                                <div className="timeline-event">
                                    <div className="timeline-header mb-sm-0 mb-3">
                                        <h6 className="mb-1 font-12">امکان کسب درآمد برای پرداخت حق بیمه و اقساط بیمه ای</h6>

                                    </div>

                                </div>
                            </li>
                            <li className="timeline-item timeline-item-danger mb-4">
                          <span className="timeline-indicator timeline-indicator-danger">
                            8
                          </span>
                                <div className="timeline-event">
                                    <div className="timeline-header mb-sm-0 mb-3">
                                        <h6 className="mb-1 font-12">امکان کسب درآمد ماهیانه با درآمد بالا برای کاربران و نمایندگان فروش</h6>

                                    </div>
                                </div>
                            </li>
                            <li className="timeline-item timeline-item-info mb-4">
                          <span className="timeline-indicator timeline-indicator-info">
                            9
                          </span>
                                <div className="timeline-event">
                                    <div className="timeline-header">
                                        <h6 className="mb-1 font-12">و ده ها مزیت دیگر ...</h6>

                                    </div>


                                </div>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            </div>

            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                    <div className="col-12">
                        <div
                            className={`col-12 mt-10 text-center cursor-pointer imageCard mb-0 position-relative pt-3`}>

                            <div className={`mb-2 card bg-white text-white mb-0  position-relative`}>
                                <p className={"text-center mt-2 m-0 text-blue font-12 mt-4"}><strong>قدرتمندترین طرح
                                    های</strong></p>
                                <p className={"text-center mb-2 m-0  text-blue font-12"}>

                                    <strong>

                                        <i
                                            className={"fa fa-arrow-down pe-2"}></i> بیمه عمر، مستمری و سرمایه گذاری<i
                                        className={"fa fa-arrow-down ps-2"}></i>
                                    </strong>

                                </p>

                                <div className={`card-header cursor-pointer plr-0 bg-white mb-0  position-relative`} onClick={() => setIsOpenFara(true)}>
                                    <span className={'text-black bannerData'}>
                                        <i><img src="/images/r.webp" className={"w-25"}/></i>
                                         طرح فرا بیمه
                                        <i><img src="/images/l.webp" className={"w-25"}/></i>

                                    </span>
                                    <p className={"text-black mb-2 font-12"}>طرح مشترک بانک ملت و بیمه ما</p>


                                    <img src="/images/bime1.jpg"
                                         className={"w-50 borderRadius5 position-relative zindex-5 mb"}/>
                                    <div className={"box3 box"}>
                                        <p className={"text-black m-2 font-12 textBox3"}>
                                            طرح فرا بیمه یکی از جدیدترین و جذابترین طرح های سرمایه گذاری و بیمه ای طرح فرا بیمه یکی از جدیدترین و جذابترین طرح های سرمایه گذاری و بیمه ای بانک ملت و بیمه ما می باشد که مزایای متعددی را برای بیمه گذاران به همراه دارد.واقع فرا بیمه یک طرح بیمه ای با تسهیلات بانکی بدون نیاز به ضامن می باشد. به عبارتی در این طرح بیمه گذاران می توانند بدون نیاز به ضامن کل حق بیمه فرد را به صورت یکجا از بانک ملت وام دریافت کنند و در کنار دریافت این وام، از پوشش های بیمه عمر و سرمایه گذاری نیز بهره مند شوند.
                                        </p>
                                        <div className={"col-12 centered text-center"}>

                                            <p className={"btn text-center ms-1 me-1 bg-blue text-white borderRadius5 w-fit-content pe-2 ps-2 m-auto font-12 pt-1 pb-1"}>بیشتر
                                                بخوانید ...</p>
                                        </div>
                                    </div>

                                </div>
                                <div className={`card-header cursor-pointer plr-0 bg-white mb-0  position-relative`} onClick={() => setIsOpenMehr(true)}>
                                    <span className={'text-black bannerData'}>
                                        <i><img src="/images/r.webp" className={"w-25"}/></i>
                                         طرح مهر ما
                                        <i><img src="/images/l.webp" className={"w-25"}/></i>

                                    </span>
                                    <p className={"text-black mb-2 font-12"}>طرح مشترک بانک مهر و بیمه ما</p>


                                    <img src="/images/photo1.jpg"
                                         className={"w-50 borderRadius5 position-relative zindex-5 mb"}/>
                                    <div className={"box3 box"}>
                                        <p className={"text-black m-2 font-12 textBox3"}>
                                            طرح مهر ما یکی از جدیدترین و کاربردی ترین طرح های شرکت بیمه ما است که به تازگی ارائه شده است. این طرح بین شرکت بیمه ما و بانک قرض الحسنه مهر ایران بوده و به منظور تامین مالی حق بیمه های عمر و مستمری می باشد. به صورت خلاصه باید بدانید که در این طرح، بانک قرض الحسنه مهر ایران حق بیمه عمر را پرداخت کرده و بیمه گذاران می توانند از پوشش های بیمه عمر و سرمایه گذری بهره مند گردد.
                                        </p>
                                        <div className={"col-12 centered text-center"}>

                                            <p className={"btn text-center ms-1 me-1 bg-blue text-white borderRadius5 w-fit-content pe-2 ps-2 m-auto font-12 pt-1 pb-1"}>بیشتر
                                                بخوانید ...</p>
                                        </div>
                                    </div>

                                </div>
                                <div className={`card-header cursor-pointer plr-0 bg-white mb-0  position-relative`} onClick={() => setIsOpenShooka(true)}>
                                    <span className={'text-black bannerData'}>
                                        <i><img src="/images/r.webp" className={"w-25"}/></i>
                                         طرح شوکا البرز
                                        <i><img src="/images/l.webp" className={"w-25"}/></i>

                                    </span>
                                    <p className={"text-black mb-2 font-12"}>طرح مشترک بانک مهر و بیمه البرز</p>


                                    <img src="/images/photo2.jpg"
                                         className={"w-50 borderRadius5 position-relative zindex-5 mb"}/>
                                    <div className={"box3 box"}>
                                        <p className={"text-black m-2 font-12 textBox3"}>
                                            بیمه البرز یکی از قدیمی و معتبرترین شرکت‌های بیمه است که خدمات مربوط به بیمه عمر را تحت عنوان "بیمه زندگی" ارائه می‌کند. طرح شوکا بیمه البرز، یکی از جدیدترین طرح های بیمه عمر شرکت بیمه البرز می باشد که همه افراد می توانند این بیمه نامه را به راحتی خریداری کرده و در بازه زمانی کوتاه مدت، بازنشستگی دریافت نمایند.
                                        </p>
                                        <div className={"col-12 centered text-center"}>

                                            <p className={"btn text-center ms-1 me-1 bg-blue text-white borderRadius5 w-fit-content pe-2 ps-2 m-auto font-12 pt-1 pb-1"}>بیشتر
                                                بخوانید ...</p>
                                        </div>
                                    </div>

                                </div>
                                <div className={`card-header cursor-pointer plr-0 bg-white mb-0  position-relative`} onClick={() => setIsOpenBaran(true)}>
                                    <span className={'text-black bannerData'}>
                                        <i><img src="/images/r.webp" className={"w-25"}/></i>
                                         طرح مهر باران
                                        <i><img src="/images/l.webp" className={"w-25"}/></i>

                                    </span>
                                    <p className={"text-black mb-2 font-12"}>طرح مشترک بانک مهر و بیمه باران</p>


                                    <img src="/images/photo3.jpg"
                                         className={"w-50 borderRadius5 position-relative zindex-5 mb"}/>
                                    <div className={"box3 box"}>
                                        <p className={"text-black m-2 font-12 textBox3"}>
                                            بیمه باران نیز همچون سایر بیمه‌های معرفی شده یکی از شرکت‌های بیمه معتبر در کشور می‌باشد. بیمه باران در طرح مهر باران با همکاری بانک مهر برای بیمه گذاران تسهیلات بانکی بدون نیاز به ضامن رائه می‌نماید به عبارتی در این طرح مه‌گذاران می‌توانند بدون نیاز به ضامن کل حق بیمه فرد را به صورت یکجا از بانک مهر وام دریافت کنند در کنار دریافت این وام از پوشش‌های بیمه عمر و سرمایه‌گذاری نیز بهره‌مند شوند
                                        </p>
                                        <div className={"col-12 centered text-center"}>

                                            <p className={"btn text-center ms-1 me-1 bg-blue text-white borderRadius5 w-fit-content pe-2 ps-2 m-auto font-12 pt-1 pb-1"}>بیشتر
                                                بخوانید ...</p>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className={"col-12"}>
                            <div className="col-12 mb-2 card  text-white  p-2 prl-10">

                            <span className="mb-0 titleBorder1">همکاران بیمه ای</span>
                                <div className="line"></div>
                                <div className="col-12 m-1">
                                    <Slider3Image/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Modal
                isOpen={isOpenFara}
                onClose={() => setIsOpenFara(false)}
                size="md"
            >
                <div className={"row"}>
                    <div className="col-xl-12">
                        <p className="text-justify">طرح فرا بیمه یکی از جدیدترین و جذابترین طرح های سرمایه گذاری و بیمه ای بانک ملت و بیمه ما می باشد که مزایای متعددی را برای بیمه گذاران به همراه دارد.واقع فرا بیمه یک طرح بیمه ای با تسهیلات بانکی بدون نیاز به ضامن می باشد. به عبارتی در این طرح بیمه گذاران می توانند بدون نیاز به ضامن کل حق بیمه فرد را به صورت یکجا از بانک ملت وام دریافت کنند و در کنار دریافت این وام، از پوشش های بیمه عمر و سرمایه گذاری نیز بهره مند شوند.</p>
                        <p className="text-justify">طرح فرابیمه چیست؟</p>
                        <p className="text-justify">طرح فرا بیمه ارائه بیمه عمر و مستمری با استفاده از تسهیلات بانکی بدون نیاز به ضامن می باشد. این طرح در حال حاضر یک تفاهم نامه بین بیمه ما و بانک ملت است و در حال حاضر بیمه گزاران می توانند حداکثر تا مبلغ 200 میلیون تومان از بانک درخواست وام برای طرح فرا بیمه نمایند. به صورت خلاصه باید گفت که بیمه گزاران با درخواست طرح فرا بیمه می توانند از بانک وام دریافت کنند، که این وام به شرکت بیمه ما پرداخت شده و بیمه گزاران تحت پوشش های بیمه عمر و سرمایه گذاری با سقف های بالا قرار خواهند گرفت و مبلغ وام در اقساط 36 ماهه از طرف بیمه گزار تسویه می گردد و تا انتهای قرارداد نیاز به پرداخت هیچگونه وجهی نخواهد بود</p>
                    </div>
                </div>
            </Modal>
            <Modal
                isOpen={isOpenMehr}
                onClose={() => setIsOpenMehr(false)}
                size="md"
            >
                <div className={"row"}>
                    <div className="col-xl-12">
                        <p className="text-justify">طرح مهر ما یکی از جدیدترین و کاربردی ترین طرح های شرکت بیمه ما است که به تازگی ارائه شده است. این طرح بین شرکت بیمه ما و بانک قرض الحسنه مهر ایران بوده و به منظور تامین مالی حق بیمه های عمر و مستمری می باشد. به صورت خلاصه باید بدانید که در این طرح، بانک قرض الحسنه مهر ایران حق بیمه عمر را پرداخت کرده و بیمه گذاران می توانند از پوشش های بیمه عمر و سرمایه گذری بهره مند گردد.</p>
                        <p className="text-justify">در این طرح شما می توانید تا سقف 200 میلیون تومان درخواست وام داشته باشید، سپس وام شما از بانک قرض الحسنه ایران به حساب شرکت بیمه ما واریز می شود و شما تحت پوشش های بیمه عمر و سرمایه گذاری بیمه ما قرار خواهید گرفت. لازم به ذکر است که وام دریافتی با نرخ 4 درصد بوده و شما باید اقساط این وام را به بانک قرص الحسنه مهر ایران پرداخت نمایید. در این طرح شما موظف هستید به مدت 60 ماه یا به عبارتی 5 سال اقساط وام دریافتی را با نرخ سود 4 درصد پرداخت کنید و پس از این مدت می توانید مستمری دریافت نمایید.</p>
                        <p className="text-justify">دریافت وام در طرح مهر ما برای خرید بیمه های عمر و سرمایه گذاری، عمر و مستمری، آتیه فرزندان، زنان خانه دار، عمر بازنشستگی و … کاربرد دارد.</p>
                    </div>
                </div>
            </Modal>
            <Modal
                isOpen={isOpenBaran}
                onClose={() => setIsOpenBaran(false)}
                size="md"
            >
                <div className={"row"}>
                    <div className="col-xl-12">
                        <p className="text-justify">بیمه باران نیز همچون سایر بیمه‌های معرفی شده یکی از شرکت‌های بیمه معتبر در کشور می‌باشد. بیمه باران در طرح مهر باران با همکاری بانک مهر برای بیمه گذاران تسهیلات بانکی بدون نیاز به ضامن رائه می‌نماید به عبارتی در این طرح مه‌گذاران می‌توانند بدون نیاز به ضامن کل حق بیمه فرد را به صورت یکجا از بانک مهر وام دریافت کنند در کنار دریافت این وام از پوشش‌های بیمه عمر و سرمایه‌گذاری نیز بهره‌مند شوند</p>
                        <p className="text-justify">بیمه باران با همکاری بانک قرص الحسنه مهر ایران، طرح مهر باران را ارائه کرده است. این طرح سرمایه گذاری را در کنار بازنشستگی کوتاه مدت برای بیمه گذاران فراهم کرده است. بیمه گذاران می‌توانند وام بدون نیاز به ضامن و سپرده اولیه در این طرح دریافت کرده و بعد از بازپرداخت آن به صورت اقساط ماهانه به مدت ۵ سال ، مستمری ماهانه و مادام العمر را در کنار اندوخته بیمه نامه دریافت نمایند.</p>
                        <p className="text-justify">میزان وامی که هر فرد در طرح مهر باران بیمه باران می‌تواند دریافت نماید، تا سقف ۲۰۰ میلیون تومان می‌باشد. اقساط باز پرداخت این بیمه نامه با توجه میزان وام متفاوت می‌باشد. در نظر داشته باشید این وام بعد از درخواست بیمه گذار به حساب بیمه نامه واریز می‌شود و نیازی به سپرده بانکی و ضامن و وثیقه ندارد.</p>
                        <p className="text-justify">در این طرح فرد بیمه شده می تواند در پایان سال پنجم، مستمری ( حقوق بازنشستگی ) به صورت ماهانه دریافت نمایید.</p>
                    </div>
                </div>
            </Modal>
            <Modal
                isOpen={isOpenShooka}
                onClose={() => setIsOpenShooka(false)}
                size="md"
            >
                <div className={"row"}>
                    <div className="col-xl-12">
                        <p className="text-justify">بیمه البرز یکی از قدیمی و معتبرترین شرکت‌های بیمه است که خدمات مربوط به بیمه عمر را تحت عنوان "بیمه زندگی" ارائه می‌کند. طرح شوکا بیمه البرز، یکی از جدیدترین طرح های بیمه عمر شرکت بیمه البرز می باشد که همه افراد می توانند این بیمه نامه را به راحتی خریداری کرده و در بازه زمانی کوتاه مدت، بازنشستگی دریافت نمایند.</p>
                        <p className="text-justify">بیمه البرز با همکاری بانک قرص الحسنه مهر ایران، طرح شوکای بیمه البرز را ارائه کرده است. این طرح سرمایه گذاری را در کنار بازنشستگی کوتاه مدت برای بیمه گذاران فراهم کرده است. بیمه گذاران می‌توانند وام بدون نیاز به ضامن و سپرده اولیه در این طرح دریافت کرده و بعد از بازپرداخت آن به صورت اقساط ماهانه به مدت ۵ سال ، مستمری ماهانه و مادام العمر را در کنار اندوخته بیمه نامه دریافت نمایند.</p>
                        <p className="text-justify">میزان وامی که هر فرد در طرح شوکا بیمه البرز می‌تواند دریافت نماید، تا سقف ۲۰۰ میلیون تومان می‌باشد. اقساط باز پرداخت این بیمه نامه با توجه میزان وام متفاوت می‌باشد. در نظر داشته باشید این وام بعد از درخواست بیمه گذار به حساب بیمه نامه نامه واریز می‌شود و نیازی به سپرده بانکی و ضامن و وثیقه ندارد.</p>
                        <p className="text-justify">در این طرح فرد بیمه شده می تواند در پایان سال پنجم مستمری ( حقوق بازنشستگی ) به صورت ماهانه دریافت نمایید.</p>
                    </div>
                </div>
            </Modal>
            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                size="xl"
            >
                <div className={"row"}>

                    <div className="col-xl-12">
                        <div className="col-12 mb-1">
                            <p>
                                کاربر عزیز سلام
                            </p>
                            <p>
                                به سوپر اپلیکیشن کسب درآمد کارسود خوش آمدید
                            </p>
                            <p>
                                اگر می‌خواهید در مورد قسمت‌های مختلف اپلیکیشن اطلاعات کسب کنید یا درمورد هر قسمتی سوال
                                دارید میتوانید روی علامت راهنما ( ؟ ) در آن قسمت کلیک کنید و اطلاعات مربوط به آن را
                                مطالعه کنید
                            </p>
                            <hr/>
                            <p>
                                توضیح کلی در مورد کارسود و نحوه کسب درآمد👇
                            </p>
                            <p>کارسود یک سوپر اپلیکیشن کسب درآمد است که شما می‌توانید علاوه بر اینکه خدمات مورد نیاز
                                خودتان را از این اپلیکیشن استفاده کنید ، می‌توانید درآمد هم کسب کنید
                            </p>
                            <p>
                                یکی از راه‌های کسب درآمد دیدن تبلیغات است ، شما با استفاده از خدمات اپلیکیشن می توانید
                                امتیاز بگیرید و در ازای هر امتیازی که گرفتید می‌توانید یک تبلیغ با کارمزد و درآمد مشخص
                                مشاهده کنید
                            </p>
                            <p>
                                ابتدا تعداد امتیازها ، کارمزد و درآمد شما از هر تبلیغ اندک و ناچیز است ولی رفته رفته بعد
                                از مدتی با افزایش فعالیت شما در اپلیکیشن امتیازات بیشتر با کارمزد و درآمد بیشتر به شما
                                داده خواهد شد و به مرور درآمد شما افزایش پیدا می‌کند یعنی هرچه بیشتر در اپلیکیشن فعالیت
                                داشته باشید و از خدمات مختلف اپلیکیشن استفاده کنید علاوه بر اینکه امتیازهای بیشتری
                                می‌گیرید ، کارمزدی که از هر تبلیغ دریافت می‌کنید مبلغ آن بیشتر می‌شود
                            </p>
                            <p>
                                خدمات موجود در اپلیکیشن خدمات کاربردی و مورد نیاز شماست به عنوان مثال خرید شارژ تلفن
                                همراه ، خرید بسته اینترنتی ، پرداخت قبوض خرید از فروشگاه‌هایی که با کارسود قرارداد دارند
                                ، خرید انواع بیمه نامه ها ، بلیط قطار ، اتوبوس و هواپیما خرید آموزش‌های کاربردی صوتی و
                                تصویری و کلی خدمات و امکانات دیگر که بخشی از آنها روی اپلیکیشن قرار گرفته و بخشی دیگر در
                                حال آماده‌سازی برای اضافه شدن به اپلیکیشن می‌باشد و کلی خدمات و امکانات دیگر که در آینده
                                به این سیستم اضافه خواهد شد همه این‌ خدمات و امکانات نیازهای روزمره شما را تامین خواهد
                                کرد و شما با استفاده از این خدمات می توانید امتیاز بگیرید و تبلیغ ببینید

                            </p>
                            <p>
                                جالبه بدونید در صورت تمایلتان ، این امکان برای شما وجود دارد تا خدمات ، محصولات و
                                امکانات روی اپلیکیشن را به سایرین بفروشید مثل فروش انواع بیمه نامه ، فروش تورهای مسافرتی
                                فروش محصولات فروشگاه آنلاین و ...... و از این طریق نیز درآمد کسب کنید

                            </p>
                            <p>
                                یکی دیگر از راه‌هایی که می‌توانید امتیاز خیلی زیاد و همیشگی بگیرید معرفی اپلیکیشن به
                                دیگران می باشد ، زمانی که سایرین با کد دعوت شما ثبت نام کنند اپلیکیشن به شما امتیاز
                                می‌دهد و شما از هر نفری که با کد شما ثبت نام کند و عضو کارسود شود می توانید درآمد همیشگی
                                و نامحدود داشته باشید این افراد هر کاری که در اپلیکیشن انجام بدهند و از هر خدمات و
                                امکاناتی که استفاده بکنند و یا فروش انجام بدهند هم خودشان درآمد کسب می‌کنند و هم اینکه
                                به شما که معرف آنها هستید امتیاز و درآمد داده می‌شود ، هرچه بیشتر این افراد در اپلیکیشن
                                فعالیت کنند و هرچه بیشتر درآمد کسب کنند درآمد شما نیز بیشتر خواهد شد و امتیاز و تبلیغ
                                بیشتری با کارمزد های بالاتر دریافت می‌کنید زیرا این افراد را شما معرفی کرده‌اید و به
                                آنها کمک کرده اید که به درآمد برسند ، این امتیازها و درآمدهایی که از این افراد می‌گیرید
                                در واقع کارمزد و پاداش معرفی و کمک به این افراد است

                            </p>
                            <p>
                                یک سری طرح‌های درآمدی روی این اپلیکیشن طراحی شده و شما می‌توانید از درآمدهایی که از
                                کارسود کسب کرده‌اید آنها را فعال کنید و سهام‌دار آن طرح‌ها بشوید
                            </p>
                            <p>
                                همه افرادی که با کد شما ثبت نام کرده‌اند زمانی که این طرح‌ها را فعال کنند علاوه بر اینکه
                                خودشان امتیاز بیشتر می‌گیرند اپلیکیشن به شما نیز که معرف آنها هستید امتیاز و تبلیغ
                                بیشتری می‌دهد و به این شکل شما می‌توانید درآمد میلیونی و همیشگی کسب کنید

                            </p>
                            <p>
                                نکته مهم:
                            </p>
                            <p>
                                اگر افرادی که معرفی کرده‌اید طرح‌های درآمدی را فعال کنند و شما فعال نکنید امتیازات و
                                تبلیغات طرح‌هایی که اون افراد فعال کردند را دریافت نمی‌کنید و امتیازاتتان از آن قسمت
                                میسوزد پس سعی کنید قبل از آن افراد طرح‌ها را فعال کنید
                            </p>
                        </div>

                    </div>

                </div>
            </Modal>
        </>
    )
}